module.exports = __webpack_public_path__ + "img/musical.e7effb71.gif";